module.exports = __webpack_public_path__ + "img/yuedu.69ba8903.jpg";